import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="app-footer">
      <span>|</span>
      <Link to="/disclaimer">Disclaimer</Link>
      <span>|</span>
      <Link to="/privacy">Privacy</Link>
      <span>|</span>
      <Link to="/about">About</Link>
      <span>|</span>
      <Link to="/contact">Contact</Link>
      <span>|</span>
    </footer>
  );
}

export default Footer;